/**
 * 画面ごとの <title>（「画面名 | Pcrm Cloud」。03 3.16 の 1）。
 */
import { useEffect } from 'react';

export const APP_TITLE = 'Pcrm Cloud';

export function usePageTitle(page_name: string): void {
  useEffect(() => {
    document.title = `${page_name} | ${APP_TITLE}`;
  }, [page_name]);
}
